<div class="job-card">
    <!-- Job Details -->
    <div class="job-content">
      <img alt="Company logo" class="job-image" height="100" [src]="job.banner?.url" width="100"/>
      <div class="job-details">
        <div class="job-title">{{ job.campaign_name }}</div>
        <div class="company-name">{{ job.department.name }}</div>
        <div class="location">{{ job.workplace }}</div>
        <div class="salary-range">{{ 'Salary' | translate }}: {{ currency.symbol }}{{ job.starting_salary_from | number }} - {{ currency.symbol }}{{ job.starting_salary_to | number }}</div>
        <div [innerHtml]="job.job_description" class="job-description"></div>
      </div>
    </div>
    <!-- Buttons -->
    <div class="button-group">
      <button class="btn btn-custom btn-apply" (click)="applyToJob()" [disabled]="job.applied_job">
        <i class="fa fa-check"></i> {{ job.applied_job ? ('Applied' | translate) : ('Apply' | translate) }}
      </button>
      <button class="btn btn-custom btn-save" (click)="toggleSave()">
        <i class="fa fa-bookmark"></i> {{ job.saved_job ? ('Unsave' | translate) : ('Save' | translate) }}
      </button>
      <a [routerLink]="['/hr/recruitments/job-details', job.id]" class="btn btn-custom btn-details">
        <i class="fa fa-info-circle"></i> {{ 'Details' | translate }}
      </a>
    </div>
  </div>
  